var ScreenTypeEnum = {
  PARENT: 'PARENT',
  CUSTOM: 'CUSTOM',
  POWERBI: 'POWERBI',
  REPORT: 'REPORT'
};

export default ScreenTypeEnum;
